import axios from "axios"
import { smlUrl,appUrl } from "../../../../../utils/config"
import {FETCH_PO_LINE_AUDIT_DETAILS_NEW,
    FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING} from "../types"

// let purchaseOrderSource;
export const fetchPOLineAuditDetailsNew = (data) => (dispatch) => {
  // if (purchaseOrderSource !== undefined) {
  //   purchaseOrderSource.cancel('Request cancelled');
  // }

  // const CancelToken = axios.CancelToken;
  // purchaseOrderSource = CancelToken.source();
  dispatch({
    type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
    payload: true,
  });
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineAuditDetailsNew`,
        data
        // ,{
        //   cancelToken: purchaseOrderSource.token,
        // }
      )
      .then((res) => {
        dispatch({
          type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
          payload: false,
        });
        if (res.status === 200) {
          dispatch({
            type: FETCH_PO_LINE_AUDIT_DETAILS_NEW,
            payload: res.data,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_PO_LINE_AUDIT_DETAILS_NEW,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_PO_LINE_AUDIT_DETAILS_NEW,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
    };
   
 